<template>
    <div class="left_panel design_studio_panel text-shape">
        <div class="edit-template" v-show="colorList">
            <ColorList
                :colorList="colorList"
                :showColorList="showColorList"
                :colorListValue="colorListValue"
                :checkDefaultValue="true"
                :selectedDefaultHex="selectedDefaultHex"
                :closeEdit="closeColorList"
                :canvasActiveObj="canvasActiveObject"
                :value="color"
                v-on:set-value="setColor"
                @undoAndRedoImageColor="saveCanvasDataInColor"
                @triggerLoaderGrandChild="triggerLoaderGrandChild"
                :vendor_colors_list="vendor_colors_list"
                :has-service-color-type="hasServiceColorType"
                :decorationType="decorationType"
            />
        </div>
        <div class="edit-template" v-show="add_distress_images">
            <DistressImageList
                :addDistressImage="add_distress_images"
                :showImageList="showImageList"
                :closeImageList="closeImageList"
                :canvasActiveObj="canvasActiveObject"
                v-on:set-value="updateDistressImage"
            />
        </div>

        <div
            v-show="text_shape"
            class="tools_headding catgory_headding w-100 add_txt text_shape_custom"
        >
            <span @click="closeShapeMenu('add-shape')"
                ><img src="/maincss/images/tool_back_arrow.svg"
            /></span>
            <h4 @click="closeShapeMenu('add-shape')" class="heading5">
                Text Shape
            </h4>
            <a
                href="#"
                @click="closeShapeMenu('add-shape')"
                title="Close"
                class="ml-auto"
                ><img src="/maincss/images/tool_close.svg" alt=" "
            /></a>
        </div>

        <div
            v-show="font_type_list"
            class="tools_headding catgory_headding w-100 add_txt text_shape_custom"
        >
            <!-- <span @click="close_font_tab()"><img src="/maincss/images/tool_back_arrow.svg" /></span> -->
            <h4 @click="close_font_tab()" class="heading5">Font Categories</h4>
            <a href="#" @click="close_font_tab()" title="Close" class="ml-auto"
                ><img src="/maincss/images/tool_close.svg" alt=" "
            /></a>
        </div>
        <div v-show="text_full_part">
            <div
                v-show="!colorList && !add_distress_images && add_text"
                class="tools_headding catgory_headding w-100 add_txt"
            >
                <h4 class="heading5"><a href="#">
                    <!-- <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 1L1 6.5L6 12" stroke="#1D6CB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg> -->
</a><span>{{ getActive() }}</span></h4>
                <a
                    href="#"
                    @click="$emit('closeMenu', 'add-text')"
                    title="Close"
                    class="ml-auto"
                    ><img src="/maincss/images/tool_close.svg" alt=" "
                /></a>
            </div>
            <div
                v-show="!colorList && add_text"
                class="center_layering_filip center_main_box_layer_custom new_align_layers"
            >
                <!-- <Center v-on:set-value="setCenter" /> -->
                <Layering :value="layer" v-on:set-value="setLayer" />
                <Flip
                    :flip-x="flipX"
                    :flip-y="flipY"
                    v-on:set-value="setFlip"
                />
                <Duplicate
                    :setClass="'   '"
                    v-on:set-value="addDuplicate"
                    :value="text"
                />
            </div>
            <div
                v-show="!colorList && !add_distress_images"
                class="well p-0 m-0 add_text_top_text_area new_des_text"
            >
                <TextArea
                    v-show="add_text"
                    :text="text"
                    v-on:set-value="setText"
                />
                <div v-show="add_text" class="custome_div mt_16"></div>
                <div
                    class="left_panel design_studio_panel add_text_block pl_0 add-text-panel"
                >
                    <div class="font_categories">
                        <div
                            v-show="font_type"
                            @click="open_font_tab()"
                            class="tools_headding catgory_headding w-100 font_category"
                        >
                            <h4 v-show="font_type">
                                Font Categories
                            </h4>
                            <a
                                v-show="font_type"
                                href="#"
                                class="ml-auto font_name"
                                ><span>{{ fontName }}</span
                                ><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 1L6 6L1 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg></a>
                        </div>

                        <div v-show="!font_type">
                            <FontType
                                :value="fontFamily"
                                :fontText="text"
                                v-on:set-value="setFontType"
                                ref="fontRef"
                            />
                        </div>
                    </div>
                </div>
                <div v-show="add_text" class="center_color_box">
                    <ColorBox
                        :value="color"
                        v-on:set-value="showColorList"
                        @click.native="getColorFind('color')"
                    />
                </div>
                <FontStyle
                    v-show="add_text"
                    :fontStyle="fontStyle"
                    v-on:set-fontStyle-value="setFontStyle"
                    :fontWeight="fontWeight"
                    v-on:set-textDecoration-value="setTextDecoration"
                    v-on:set-UDecoration-value="setUDecoration"
                    v-on:set-fontWeight-value="setFontWeight"
                    :textDecoration="textDecoration"
                    :textUDecoration="textUDecoration"
                />
                <div
                    v-show="add_text"
                    class="align_full_width align_full_box_main"
                >
                    <TextAlign
                        v-show="add_text"
                        :value="textAlign"
                        v-on:set-value="setTextAlign"
                    />
                    <Center
                        v-show="add_text"
                        :value="center"
                        v-on:set-value="setCenter"
                    />
                </div>

                <Rotation
                    v-show="add_text"
                    :value="rotation"
                    v-on:set-value="setRotation"
                />
                <div
                    v-show="add_text"
                    class="emboss_deboss_checkbox_sec mt_10 mb_20"
                >
                    <div class="d-flex emboss_check_box_inner_div mr_26">
                        <Emboss
                            :value="embossShadow"
                            v-on:set-value="showDiv"
                        />
                    </div>
                    <div class="shadow_section" v-show="embossShadow">
                        <EmbossBox
                            :value="emboss"
                            :directionShadow="directionShadow"
                            v-on:set-value="setEmboss"
                        />
                        <div class="bottom_color_box">
                            <ColorBox
                                :value="shadowEmbossColour"
                                :showLabel="false"
                                v-on:set-value="showColorList"
                                @click.native="getColorFind('emboss')"
                            />
                        </div>
                    </div>
                </div>
                <div
                    v-show="add_text"
                    class="custome_div emboss_deboss_color_custom_main_box mt_20 rotation_invisible"
                >
                    <Deboss :value="deboss" v-on:set-value="setDeboss" />
                    <ColorBox
                        :value="shadowDebossColour"
                        :showLabel="false"
                        v-on:set-value="showColorList"
                        @click.native="getColorFind('deboss')"
                    />
                </div>
            </div>
        </div>
        <div class="t-shape_t-text">
            <div class="test-shape" v-show="add_text_shapes">
                <p v-show="text_outline" @click="open_text_tab('text_shape')">
                    text Shape
                </p>
                <span v-show="text_outline"
                    ><img src="/maincss/images/right.png"
                /></span>
                <div v-show="text_shape" class="well p-0 m-0">
                    <div
                        class="categorys_open mt_14 shape_open"
                        style="width: 100%"
                    >
                        <div
                            id="avatarlist"
                            class="avatarlist d-flex flex-wrap well p-0 m-0"
                        >
                            <div
                                v-for="(shape, index) in shapes"
                                :key="index"
                                class="form-check pl-0 img-polaroid add_shap_pd"
                            >
                                <label class="checkbox_custom brand_logo_select"
                                    ><img
                                        :src="apiurl + shape.shape_image"
                                        :alt="shape.image_name"
                                    />
                                    <input
                                        type="checkbox"
                                        @click="
                                            placeTextShapeImage(
                                                $event,
                                                shape.shape_image,
                                                index
                                            )
                                        "
                                        v-model="shape.selected_images"
                                    /><span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { fabric } from "fabric";
import canvas from "html2canvas";
import ApiService from "@/common/api.service";
import TextArea from "../components/TextArea";
import TextAlign from "../components/TextAlign";
import Duplicate from "../components/Duplicate";
import FontType from "../components/FontType";
import FontStyle from "../components/FontStyle";
import Rotation from "../components/Rotation";
import Layering from "../components/Layering";
import Flip from "../components/Flip";
import Center from "../components/Center";
import ColorBox from "../components/ColorBox";
import ColorList from "../components/ColorListV3";
import Emboss from "../components/Emboss";
import EmbossBox from "../components/EmbossBox";
import Deboss from "../components/DebossV3";
import DistressImageList from "../components/DistressImageList";
import commonData from "@/common/common.data";
export default {
    name: "AddText",
    components: {
        TextArea,
        FontType,
        FontStyle,
        Rotation,
        Emboss,
        EmbossBox,
        Deboss,
        TextAlign,
        Duplicate,
        Layering,
        Flip,
        Center,
        ColorBox,
        ColorList,
        DistressImageList
    },

    data: () => {
        return {
            checked: false,
            text: "",
            fontFamily: "Arial",
            fontName: "Arial",
            fontStyle: "",
            fontSize: 50,
            color: "",
            rotation: 0,
            emboss: 0,
            deboss: 1,
            textAlign: "left",
            textDecoration: "",
            textUDecoration: "",
            fontWeight: "",
            layer: "",
            flip: "",
            flipX: false,
            flipY: false,
            center: "",
            colorList: false,
            text_shape: false, //enable text shape tab in Add text
            text_outline: true,
            text_full_part: true,
            add_text: true,
            add_text_shapes: false,
            add_distress_images: false,
            shapes: [],
            apiurl: ApiService.apiUrl(), //api url
            colorListValue: [],
            imageListValue: [],
            shadowEmbossColour: "#000000",
            shadowDebossColour: "#000000",
            embossShadow: false,
            directionShadow: "Top",
            shapeDir: false,
            font_type: true,
            font_type_list: false,
            selectedType: "emboss",
            selectedDefaultHex: "",
            new_color_list: []
        };
    },
    emits: ["set-value"],
    props: [
        "data",
        "addDeleteBtn",
        "canvasActiveObject",
        "designBox",
        "fontCanvasWidth",
        "fontCanvasHeight",
        "fontCanvasTop",
        "fontCanvasLeft",
        "rotationAngle",
        "designAreaAngle",
        "triggerLoader",
        "vendor_colors_list",
        "hasServiceColorType",
        "decorationType",
        "printAreaBond",
        "active_flip"
    ],
    watch: {
        data: function (newData, oldData) {
            this.shadowEmbossColour = "#000000";
            this.shadowDebossColour = "#000000";
            this.color = "#000000";
            // console.log('new '+newData.text+' Old '+oldData.text+' text '+this.text)
            if (JSON.stringify(newData) != JSON.stringify(oldData)) {
                // For hold first text value.
                let firstText = newData.text ? newData.text : this.text;
                let debos = this.deboss == 0 ? 1 : this.deboss;
                let directionShado = this.directionShadow;
                let {
                    text,
                    fontFamily,
                    fontStyle,
                    fontSize,
                    color,
                    textAlign,
                    layer,
                    flip,
                    center,
                    flipX,
                    flipY,
                    textDecoration,
                    fontWeight,
                    textUDecoration,
                    embossX,
                    embossY,
                    embossColour,
                    embossBlur,
                    paintFirst,
                    strokeWidth,
                    stroke,
                    underline,
                    linethrough
                } = newData;

                if (newData.text == oldData.text) {
                    this.text = firstText;
                    if (!this.canvasActiveObject.getActiveObject()) {
                        this.text = "";
                        this.shadowEmbossColour = "#000000";
                        this.shadowDebossColour = "#000000";
                        this.color = "#000000";
                        if (this.new_color_list.length > 0) {
                            let isBlack = true;
                            this.new_color_list.forEach((color) => {
                                if (color.color_value == "#000000")
                                    isBlack = false;
                            });
                            this.color = isBlack
                                ? this.new_color_list[0].color_value
                                : "#000000";
                        }
                    }
                } else {
                    this.text = text;
                }
                this.fontFamily = fontFamily;
                // Try to find font_name from FontType component's font list
                if (this.$refs.fontRef && this.$refs.fontRef.font_category_list) {
                    let foundFont = null;
                    this.$refs.fontRef.font_category_list.forEach((category) => {
                        if (category.Fonts && category.Fonts.length > 0) {
                            let font = category.Fonts.find(f => f.font_option === fontFamily);
                            if (font) {
                                foundFont = font;
                            }
                        }
                    });
                    this.fontName = foundFont ? foundFont.font_name : fontFamily;
                } else {
                    // Fallback: use fontFamily as fontName if font list not available
                    this.fontName = fontFamily;
                }
                this.fontStyle = fontStyle;
                this.textDecoration = textDecoration;
                this.textUDecoration = textUDecoration;
                this.fontWeight = fontWeight;
                this.fontSize = fontSize;
                let rgbExpression = /^rgb\(\d{3}/;
                if (color.match(rgbExpression))
                    this.color = this.rgbToHex(color);
                else this.color = color.toUpperCase();
                if (!color) {
                    this.color = "#000000";
                    this.shadowEmbossColour = "#000000";
                    this.shadowDebossColour = "#000000";
                    if (this.new_color_list.length > 0) {
                        let isBlack = true;
                        this.new_color_list.forEach((color) => {
                            if (color.color_value == "#000000") isBlack = false;
                        });
                        this.color = isBlack
                            ? this.new_color_list[0].color_value
                            : "#000000";
                    }
                }
                this.rotation = Math.ceil(this.rotationAngle);
                this.textAlign = textAlign;
                this.layer = layer;
                this.flip = flip;
                this.center =
                    center !== undefined && center !== null && center !== ""
                        ? center
                        : "left";
                if (Object.prototype.hasOwnProperty.call(newData, "flipX")) {
                    this.flipX =
                        typeof flipX === "boolean"
                            ? flipX
                            : flipX != null
                              ? !!flipX
                              : false;
                }
                if (Object.prototype.hasOwnProperty.call(newData, "flipY")) {
                    this.flipY =
                        typeof flipY === "boolean"
                            ? flipY
                            : flipY != null
                              ? !!flipY
                              : false;
                }
                this.colorList = false;
                this.shadowEmbossColour = embossColour;
                this.deboss = debos;
                this.directionShadow = directionShado;
                this.colorListValue = [];
                if (embossBlur > 0) {
                    this.embossShadow = true;
                    this.emboss = (embossBlur - 10) * 5;
                    switch (true) {
                        case Math.sign(embossX) == -1 &&
                            Math.sign(embossY) == -1:
                            this.directionShadow = "Left";
                            break;
                        case Math.sign(embossX) == 1 && Math.sign(embossY) == 1:
                            this.directionShadow = "Right";
                            break;
                        case Math.sign(embossX) == 1 &&
                            Math.sign(embossY) == -1:
                            this.directionShadow = "Top";
                            break;
                        case Math.sign(embossX) == -1 &&
                            Math.sign(embossY) == 1:
                            this.directionShadow = "Bottom";
                            break;
                        default:
                            this.directionShadow = "Top";
                    }
                    this.colorListValue.push(this.color);
                    this.colorListValue.push(this.shadowEmbossColour);
                } else {
                    this.embossShadow = false;
                    this.emboss = 0;
                }
                if (paintFirst == "stroke") {
                    this.deboss = strokeWidth * 4;
                    this.shadowDebossColour = stroke;
                    this.colorListValue.push(this.color);
                    this.colorListValue.push(this.shadowDebossColour);
                } else {
                    this.deboss = 1;
                }
                if (typeof color != "string") {
                    this.checked = true;
                }
                if (typeof underline === "boolean") {
                    this.textUDecoration = underline ? "underline" : "";
                } else if (underline === "underline") {
                    this.textUDecoration = "underline";
                }
                if (typeof linethrough === "boolean") {
                    this.textDecoration = linethrough ? "linethrough" : "";
                } else if (linethrough === "linethrough") {
                    this.textDecoration = "linethrough";
                }
                this.close_font_tab();
            }
        },
        rotationAngle: function (newData, oldData) {
            if (newData != oldData) this.rotation = Math.ceil(newData);
        },
        vendor_colors_list: function (newData, oldData) {
            if (newData != oldData) this.new_color_list = newData;
            this.color = "#000000";
            if (this.new_color_list.length > 0) {
                let isBlack = true;
                this.new_color_list.forEach((color) => {
                    if (color.color_value == "#000000") isBlack = false;
                });
                this.color = isBlack
                    ? this.new_color_list[0].color_value
                    : "#000000";
            }
        }
    },
    beforeMount() {
        this.getShape();
    },
    methods: {
        rgbToHex(rgbColorString) {
            const rgbValues = rgbColorString.match(/\d+/g);

            if (!rgbValues || rgbValues.length != 3) {
                return rgbColorString.toLowerCase();
            }

            let r = parseInt(rgbValues[0], 10); // Red value
            let g = parseInt(rgbValues[1], 10); // Green value
            let b = parseInt(rgbValues[2], 10); // Blue value

            // Ensure that the values are within the valid range (0-255)
            r = Math.max(0, Math.min(255, r));
            g = Math.max(0, Math.min(255, g));
            b = Math.max(0, Math.min(255, b));

            // Convert each component to a hexadecimal string
            const redHex = r.toString(16).padStart(2, "0");
            const greenHex = g.toString(16).padStart(2, "0");
            const blueHex = b.toString(16).padStart(2, "0");

            // Combine the hexadecimal values to form the HEX color code
            const hexCode = `#${redHex}${greenHex}${blueHex}`;

            return hexCode.toUpperCase(); // Optional: Convert to uppercase for consistency
        },
        triggerLoaderGrandChild(currentStatus) {
            this.$emit("triggerLoader", currentStatus);
        },
        saveCanvasDataInColor() {
            this.$emit("undoAndRedo");
        },
        prepareColors(colors) {
            let allColors = [];
            commonData.colorShades.forEach((shade) => {
                colors.forEach((color) => {
                    if (color.color_value && color.shades) {
                        if (color.shades.includes(shade)) {
                            let alreadyExisted = allColors.find(
                                (col) => col.color_id == color.color_id
                            );
                            if (!alreadyExisted) {
                                allColors.push(color);
                            }
                        }
                    }
                });
            });
            colors.forEach((color) => {
                if (color.color_value) {
                    if (!color.shades || color.shades.length == 0) {
                        allColors.push(color);
                    }
                }
            });
            return allColors;
        },
        getColorFind(clickdata) {
            this.colorListValue = [];
            this.selectedType = clickdata;
            if (clickdata == "color") {
                this.colorListValue.push(this.color);
                this.selectedDefaultHex = this.color;
            } else if (clickdata == "emboss") {
                this.colorListValue.push(this.color);
                this.colorListValue.push(this.shadowEmbossColour);
                this.selectedDefaultHex = this.shadowEmbossColour;
            } else {
                this.colorListValue.push(this.color);
                this.colorListValue.push(this.shadowDebossColour);
                this.selectedDefaultHex = this.shadowDebossColour;
            }
        },
        open_font_tab() {
            this.text_outline = false;
            this.text_full_part = true;
            this.add_text = false;
            this.font_type = false;
            this.text_shape = false;
            this.font_type_list = true;
            this.$refs.fontRef.selectFont();
        },
        close_font_tab() {
            this.text_outline = true;
            this.text_full_part = true;
            this.add_text = true;
            this.font_type = true;
            this.text_shape = false;
            this.font_type_list = false;
            this.$refs.fontRef.close_fonts_tab();
        },
        closeShapeMenu(menu_id) {
            if (menu_id === "add-shape") {
                // this.onSelectedCleared()
                this.text_shape = false;
                this.text_outline = true;
                this.text_full_part = true;
                this.font_type_list = false;
                this.font_type = true;
                return;
            }
        },
        hidecont() {
            this.checked = !this.checked;
        },
        showColorList() {
            // this.showColorFromList();
            this.colorList = true;
            this.text_outline = false;
            this.add_text_shapes = false;
            this.add_distress_images = false;
            // alert('addtext');
        },
        showImageList() {
            this.add_distress_images = true;
            // this.colorList=false;
            this.text_outline = false;
            this.add_text_shapes = false;
            // alert('teste');
        },
        closeImageList() {
            this.add_distress_images = false;
        },
        closeColorList() {
            this.colorList = false;
            this.text_outline = true;
            //this.add_text_shapes = true;
        },
        setText(value) {
            let _this = this;
            if (
                !_this.text.length &&
                !_this.canvasActiveObject.getActiveObject()
            ) {
                _this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
                var lefts, tops;
                if (_this.printAreaBond) {
                    // Use the visual center of the rotated design area bounding rect
                    lefts = _this.printAreaBond.left + _this.printAreaBond.width / 2;
                    tops = _this.printAreaBond.top + _this.printAreaBond.height / 2;
                } else {
                    var offset = 50;
                    var w =
                        (_this.fontCanvasWidth ||
                            fabric.util.getRandomInt(0 + offset, 200 - offset)) / 2;
                    var h = _this.fontCanvasHeight / 2;
                    lefts = _this.fontCanvasLeft + w;
                    tops = _this.fontCanvasTop + h;
                }
                fabric.Object.prototype.objectCaching = false;
                this.color = "#000000";
                if (this.new_color_list.length > 0) {
                    let isBlack = true;
                    this.new_color_list.forEach((color) => {
                        if (color.color_value == "#000000") isBlack = false;
                    });
                    this.color = isBlack
                        ? this.new_color_list[0].color_value
                        : "#000000";
                }
                // Determine initial text angle to align along the strap/design area length
                var initialAngle = 0;
                if (_this.designBox && _this.designBox.angle) {
                    var boxAngle = _this.designBox.angle;
                    var boxW = _this.designBox.width * (_this.designBox.scaleX || 1);
                    var boxH = _this.designBox.height * (_this.designBox.scaleY || 1);
                    // If height >= width, the strap's long axis is the height direction (boxAngle - 90°)
                    // Text flows ALONG the strap length in the correct reading direction
                    initialAngle = boxH >= boxW ? boxAngle - 90 : boxAngle;
                    // Normalize to 0-360
                    initialAngle = ((initialAngle % 360) + 360) % 360;
                } else {
                    initialAngle = _this.designAreaAngle || 0;
                }
                var textSample = new fabric.Text(value, {
                    id: new Date() / 1,
                    left: lefts,
                    top: tops,
                    fontFamily: _this.fontFamily || "Arial",
                    angle: initialAngle,
                    fill: _this.color,
                    fontSize: 50,
                    scaleX: 0.5,
                    scaleY: 0.5,
                    originX: "center",
                    originY: "center",
                    centeredRotation: true,
                    hasRotatingPoint: true,
                    clipPath: _this.designBox || null
                });

                _this.canvasActiveObject.add(textSample);
                _this.canvasActiveObject.setActiveObject(textSample);
                _this.rotation = Math.ceil(initialAngle);
                var item = _this.canvasActiveObject.item(
                    _this.canvasActiveObject.item.length - 1
                );
                item.hasRotatingPoint = true;
                _this.addDeleteBtn(item.left, item.top, item.width, item);
            }
            _this.text = value;
            if (!this.canvasActiveObject) {
                return;
            }
            setTimeout(() => {
                var activeObject = this.canvasActiveObject.getActiveObject();

                if (activeObject && activeObject.type === "text") {
                    activeObject.text = this.text;
                    activeObject.fill = this.color;
                    activeObject.dirty = true;
                    activeObject.set("dirty", true);
                    let active_flip = localStorage.getItem("active_flip");
                    activeObject.set("clipPath", null);
                    // Set clipPath for all views (front, back, left, right) if designBox exists
                    if (_this.designBox) {
                        activeObject.set("clipPath", _this.designBox);
                    }
                    _this.canvasActiveObject.renderAll();
                    this.$emit("undoAndRedo");
                    _this.addDeleteBtn(
                        activeObject.left,
                        activeObject.top,
                        activeObject.width,
                        activeObject
                    );
                }
            }, 50);
        },
        enabled() {
            if (this.canvasActiveObject) {
                var activeObject = this.canvasActiveObject.getActiveObject();
                if (activeObject && activeObject.type === "text") {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getActive() {
            if (this.canvasActiveObject) {
                var activeObject = this.canvasActiveObject.getActiveObject();
                if (activeObject && activeObject.type === "text") {
                    return "Edit Text";
                } else {
                    return "Add Text";
                }
            } else {
                return "Add Text";
            }
        },
        setFontType(value) {
            // Handle both object (new) and string (old) format for backward compatibility
            if (typeof value === 'object' && value.font_option) {
                this.fontFamily = value.font_option;
                this.fontName = value.font_name || value.font_option;
            } else {
                // Backward compatibility: if string is passed, use it for both
                this.fontFamily = value;
                this.fontName = value;
            }
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            fabric.Object.prototype.objectCaching = false;
            if (activeObject && activeObject.type === "text") {
                var font = this.fontFamily;
                activeObject.set("fontFamily", font);
            }
            this.canvasActiveObject.renderAll();
        },
        setColor(value, oldColour) {
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            activeObject.dirty = true;
            let index = this.colorListValue.indexOf(oldColour);
            if (index < 0) index = 0;
            if (index == 0) {
                this.color = value;
                if (activeObject && activeObject.type === "text") {
                    activeObject.fill = this.color;
                    // activeObject.set({paintFirst: 'fill'});
                    this.canvasActiveObject.renderAll();
                }
            }
            if (
                index == 1 &&
                this.emboss > 0 &&
                oldColour == this.shadowEmbossColour &&
                this.selectedType == "emboss"
            ) {
                this.shadowEmbossColour = value;
                let acutalPixel = Math.round(this.emboss * 100) / 500;
                if (activeObject && activeObject.type === "text") {
                    let acutalPixelNeg = -acutalPixel;
                    let blurPixel = acutalPixel + 10;
                    let xPixel = 0;
                    let yPixel = 0;
                    switch (this.directionShadow) {
                        case "Left":
                            xPixel = acutalPixelNeg;
                            yPixel = acutalPixelNeg;
                            break;
                        case "Right":
                            xPixel = acutalPixel;
                            yPixel = acutalPixel;
                            break;
                        case "Top":
                            xPixel = acutalPixel;
                            yPixel = acutalPixelNeg;
                            break;
                        case "Bottom":
                            xPixel = acutalPixelNeg;
                            yPixel = acutalPixel;
                            break;
                        default:
                            xPixel = 0;
                            yPixel = 0;
                            blurPixel = 0;
                    }
                    activeObject.set(
                        "shadow",
                        " " +
                            this.shadowEmbossColour +
                            " " +
                            xPixel +
                            "px " +
                            yPixel +
                            "px " +
                            blurPixel +
                            "px"
                    );
                    this.canvasActiveObject.renderAll();
                }
            }
            if (
                index == 1 &&
                this.deboss > 0 &&
                oldColour == this.shadowDebossColour &&
                this.selectedType == "deboss"
            ) {
                this.shadowDebossColour = value;
                let acutalPixel = Math.round(this.deboss * 100) / 400;
                if (activeObject && activeObject.type === "text") {
                    activeObject.set({ paintFirst: "stroke" });
                    activeObject.set({ strokeWidth: acutalPixel });
                    activeObject.set({ stroke: value });
                    this.canvasActiveObject.renderAll();
                }
            }
            this.$emit("undoAndRedo");
            this.colorListValue[index] = value;
        },
        setFontStyle(value) {
            this.fontStyle = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.type === "text") {
                activeObject.fontStyle = this.fontStyle;
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
        },

        //Created by Drashti on 4th Aug 2022 start
        setTextDecoration(value) {
            this.textDecoration = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (
                activeObject &&
                activeObject.type === "text" &&
                this.textDecoration === "linethrough"
            ) {
                activeObject.set({
                    linethrough: true
                });
                this.canvasActiveObject.renderAll();
            } else {
                activeObject.set({
                    linethrough: false
                });
                this.canvasActiveObject.renderAll();
            }
            this.$emit("undoAndRedo");
        },
        setUDecoration(value) {
            // alert(value);
            this.textUDecoration = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (
                activeObject &&
                activeObject.type === "text" &&
                this.textUDecoration === "underline"
            ) {
                activeObject.set({
                    underline: true
                });
                this.canvasActiveObject.renderAll();
            } else {
                activeObject.set({
                    underline: false
                });
                this.canvasActiveObject.renderAll();
            }
            this.$emit("undoAndRedo");
        },
        //Created by Drashti on 4th Aug 2022 end

        setFontWeight(value) {
            this.fontWeight = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.type === "text") {
                activeObject.fontWeight = this.fontWeight;
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
        },

        setFontSize(value) {
            this.fontSize = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.type === "text") {
                activeObject.fontSize = Number(this.fontSize);
                let e = { target: activeObject };
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
                this.addDeleteBtn(
                    e.target.oCoords.mtr.x,
                    e.target.oCoords.mtr.y,
                    e.target.width,
                    e.target
                );
            }
        },
        setRotation(value) {
            this.rotation = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.originX = "center";
                activeObject.originY = "center";
                activeObject.angle = Number(this.rotation);
                //activeObject.setAngle(Number(this.rotation))
                let e = { target: activeObject };
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
                this.addDeleteBtn(
                    e.target.oCoords.mtr.x,
                    e.target.oCoords.mtr.y,
                    e.target.width,
                    e.target
                );
            }
        },
        setEmboss(value, dirShadow) {
            let _this = this;
            this.emboss = value;
            this.directionShadow = dirShadow;
            //alert(value +' '+dirShadow)
            if (!_this.canvasActiveObject) {
                return;
            }
            //let acutalPixel = Math.round(_this.emboss/25);
            let acutalPixel = Math.round(_this.emboss * 100) / 500;
            var activeObject = _this.canvasActiveObject.getActiveObject();
            this.colorListValue = [];
            this.colorListValue.push(this.color);
            this.colorListValue.push(this.shadowEmbossColour);
            if (activeObject && activeObject.type === "text") {
                let blurPixel = acutalPixel + 10;
                let xPixel = 0;
                let yPixel = 0;
                let acutalPixelNeg = -acutalPixel;
                switch (this.directionShadow) {
                    case "Left":
                        xPixel = acutalPixelNeg;
                        yPixel = acutalPixelNeg;
                        break;
                    case "Right":
                        xPixel = acutalPixel;
                        yPixel = acutalPixel;
                        break;
                    case "Top":
                        xPixel = acutalPixel;
                        yPixel = acutalPixelNeg;
                        break;
                    case "Bottom":
                        xPixel = acutalPixelNeg;
                        yPixel = acutalPixel;
                        break;
                    default:
                        xPixel = 0;
                        yPixel = 0;
                        blurPixel = 0;
                }
                activeObject.set(
                    "shadow",
                    " " +
                        this.shadowEmbossColour +
                        " " +
                        xPixel +
                        "px " +
                        yPixel +
                        "px " +
                        blurPixel +
                        "px"
                );

                _this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
            if (this.emboss == 0) this.colorListValue = [];
        },
        setDeboss(value) {
            let _this = this;
            this.deboss = value;
            if (!_this.canvasActiveObject) {
                return;
            }
            fabric.Object.prototype.objectCaching = false;
            let acutalPixel = Math.round(_this.deboss * 100) / 400;
            var activeObject = _this.canvasActiveObject.getActiveObject();
            this.colorListValue = [];
            this.colorListValue.push(this.color);
            this.colorListValue.push(this.shadowDebossColour);
            if (activeObject && activeObject.type === "text") {
                activeObject.set({ paintFirst: "stroke" });
                activeObject.set({ strokeWidth: acutalPixel });
                activeObject.set({ stroke: this.shadowDebossColour });

                _this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
            if (this.deboss == 0) {
                this.colorListValue = [];
                this.deboss = 0;
            }
        },
        setTextAlign(value) {
            this.textAlign = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.type === "text") {
                activeObject.textAlign = this.textAlign;
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
        },

        setCenter(e) {
            if (!this.canvasActiveObject) {
                return;
            }

            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.type === "text") {
                this.center = e;
                if (e == "center") {
                    if (
                        this.printAreaBond &&
                        typeof this.printAreaBond.left === "number" &&
                        !isNaN(this.printAreaBond.width) &&
                        this.printAreaBond.width > 0
                    ) {
                        this.process_align("centerH", activeObject);
                    } else {
                        activeObject.centerH();
                    }
                    activeObject.setCoords();
                    this.canvasActiveObject.renderAll();
                }
                if (e == "left" || e == "right") {
                    this.process_align(e, activeObject);
                    activeObject.setCoords();
                    this.canvasActiveObject.renderAll();
                }
                this.$emit("undoAndRedo");
                this.addDeleteBtn(
                    activeObject.oCoords.mtr.x,
                    activeObject.oCoords.mtr.y,
                    activeObject.width,
                    activeObject
                );
            }
        },
        setLayer(value) {
            var _this = this;
            _this.layer = value;
            if (!_this.canvasActiveObject) {
                return;
            }
            var activeObject = _this.canvasActiveObject.getActiveObject(),
                activeGroup = _this.canvasActiveObject.getActiveObject();
            _this.canvasActiveObject.preserveObjectStacking = true;
            if (activeObject) {
                if (_this.layer == "front") activeObject.bringToFront();
                else if (_this.layer == "back") {
                    activeObject.sendToBack();
                }
                _this.canvasActiveObject.renderAll();
            } else if (activeGroup) {
                var objectsInGroup = activeGroup.getObjects();
                _this.canvasActiveObject.discardActiveGroup();
                objectsInGroup.forEach(function (object) {
                    if (_this.layer == "front") object.bringToFront();
                    else if (_this.layer == "back") {
                        object.sendToBack();
                    }
                });
            }
            this.$emit("undoAndRedo");
        },
        setFlip(e) {
            // this.flip=""
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.type === "text") {
                if (e == "left") {
                    activeObject.flipX = activeObject.flipX ? false : true;
                } else if (e == "top") {
                    activeObject.flipY = activeObject.flipY ? false : true;
                }
                this.flipX = !!activeObject.flipX;
                this.flipY = !!activeObject.flipY;
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
        },
        addDuplicate() {
            //placeText()
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject && activeObject.type === "text") {
                var copied = fabric.util.object.clone(activeObject);
                this.canvasActiveObject.add(copied);
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
        },
        // here add dynamic shape
        open_text_tab(tab) {
            if (tab == "text_shape") {
                this.text_outline = false;
                this.text_full_part = false;
                this.add_text = false;
                this.text_shape = true;
            }
        },
        closeMenu(menu_id) {
            if (menu_id === "add-shape") {
                // this.onSelectedCleared()
                this.text_shape = false;
                this.text_outline = true;
                this.text_full_part = true;
                return;
            }
        },
        getData() {
            //get all
            ApiService.get("/all-data")
                .then(({ data }) => {
                    this.templates = data.all_data.templates;
                    this.cliparts = data.all_data.cliparts;
                    this.shapes = data.all_data.shapes;
                    this.patches = data.all_data.patches;
                })
                .catch(({ response }) => {
                    console.log(response);
                });
            //get saved designs
            if (this.isAuthenticatedClient) {
                ApiService.post("/saved-designs")
                    .then(({ data }) => {
                        this.savedDesigns = data.savedDesigns;
                        this.design_count = this.savedDesigns
                            ? this.savedDesigns.length
                            : 0;
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            }
        },
        getShape() {
            //get all shapes
            var _this = this;
            new Promise(() => {
                ApiService.get("/get-all-shapes")
                    .then(({ data }) => {
                        _this.shapes = data.shapes;
                    })
                    .catch(({ response }) => {
                        console.log(response.status.errors);
                    });
            });
        },
        /* eslint-disable */
        // ---------------------- Harsh Agrawal --------------------------------------------------
        process_align(val, activeObj) {
            let bound = activeObj.getBoundingRect();
            
            // Get print area boundaries
            const printArea = this.printAreaBond;
            
            // Calculate the offset between object center and bounding rect
            const offsetX = activeObj.left - (bound.left + bound.width / 2);
            const offsetY = activeObj.top - (bound.top + bound.height / 2);
            
            
            switch (val) {
                 case "left":
                    if(this.active_flip == 'front' || this.active_flip == 'back'){
                        // Align object's left edge to print area's left edge
                        const leftCenterX = printArea.left + (bound.width / 2) + offsetX;
                        activeObj.set({
                            left: leftCenterX
                        });
                    }else{
                         activeObj.set({
                        left: activeObj.left - bound.left
                            });     
                    }    
                    break;

                case "right":
                    if(this.active_flip == 'front' || this.active_flip == 'back'){// Align object's right edge to print area's right edge
                        const rightCenterX = (printArea.left + printArea.width) - (bound.width / 2) + offsetX;
                        activeObj.set({
                            left: rightCenterX
                        });
                        console.log('Setting right center position to:', rightCenterX);
                    }else{
                                    if (activeObj.angle == 0) {
                            activeObj.set({
                                left: activeObj.canvas.width - bound.width / 2 - 5
                            });
                        } else {
                            activeObj.set({
                                left: activeObj.canvas.width - bound.width / 2
                            });
                        }
                    }    
                        break;

                case "top":
                    // Align object's top edge to print area's top edge
                    const topCenterY = printArea.top + (bound.height / 2) + offsetY;
                    activeObj.set({
                        top: topCenterY
                    });
                    break;
                    
                case "bottom":
                    // Align object's bottom edge to print area's bottom edge
                    const bottomCenterY = (printArea.top + printArea.height) - (bound.height / 2) + offsetY;
                    activeObj.set({
                        top: bottomCenterY
                    });
                    break;
                    
                case "centerH":
                    // Center horizontally within print area
                    const centerX = printArea.left + (printArea.width / 2) + offsetX;
                    activeObj.set({
                        left: centerX
                    });
                    break;
                    
                case "centerV":
                    // Center vertically within print area
                    const centerY = printArea.top + (printArea.height / 2) + offsetY;
                    activeObj.set({
                        top: centerY
                    });
                    break;
            }
            
            this.$emit("undoAndRedo");
        },
        updateDistressImage(url) {
            let _this = this;
            if (!this.canvasActiveObject) {
                console.log("obj not found");
                return;
            }
            fabric.Image.fromURL(url, function (img) {
                img.set({
                    scaleX: _this.canvasActiveObject.getWidth() / img.width,
                    scaleY: _this.canvasActiveObject.getHeight() / img.height,
                    objectCaching: false,
                    originX: "left",
                    originY: "top",
                    //opacity:0.2,
                    globalCompositeOperation: "source-atop"
                });
                _this.canvasActiveObject.setOverlayImage(
                    img,
                    _this.canvasActiveObject.renderAll.bind(
                        _this.canvasActiveObject
                    )
                );
            });
        },
        showDiv(e) {
            if (e) {
                this.embossShadow = true;
                //this.$emit('set-value',Number(100));
            } else {
                this.embossShadow = false;
                this.setEmboss(0, "");
                //this.$emit('set-value',Number(0));
            }
        }
    }
};
</script>

<style>
.a_disabled button {
    cursor: not-allowed;
}
</style>
